var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-container"},[_c('router-view',{attrs:{"timer":_vm.timer,"score":_vm.score}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }